// @flow

import {
  wwwUrl,
  dashboardUrl,
  stayUrl,
  eventUrl,
  helpPaymentUrl,
} from 'frontend_core/dist/helpers/url'
import { roomName } from 'frontend_core/dist/helpers/format'
import queryString from 'query-string'
import type { Room as RoomType } from 'types/room'

export default {
  space: (spaceUsername: string = ':spaceUsername?') =>
    `/spaces/${spaceUsername}`,
  room: (
    spaceId: string = ':spaceId?',
    roomUid: string | number = ':roomId?',
  ) => `/spaces/${spaceId}/rooms/${roomUid}`,
  roomReputationList: (
    spaceUsername: string | number = ':spaceUsername?',
    roomId: string | number = ':roomId?',
  ) => `/spaces/${spaceUsername}/rooms/${roomId}/reputations`,
  topicList: () => '/topics',
  topic: (topicUid: string = ':topicUid?') => `/topics/${topicUid}`,
  tweetCampaign: (tweetCampaignUid: string = ':tweetCampaignUid?') =>
    `/campaigns/${tweetCampaignUid}`,
  search: () => '/search',
  searchB: () => '/b/search',
  searchMap: () => '/b/search/map',
  spaceReputationList: (spaceUsername: string = ':spaceUsername?') =>
    `${`/spaces/${spaceUsername}/reputations`}`,
  dashboard: () => '/dashboard',
  favoriteLists: () => '/dashboard/favorite_lists',
  favoriteListDetail: (favoriteListId: number | string = ':favoriteListId?') =>
    `/dashboard/favorite_lists/${favoriteListId}`,
  reservations: () => '/dashboard/reservations',
  reservationDetail: (reservationUid: number | string = ':reservationId?') =>
    `/dashboard/reservations/${reservationUid}`,
  reservationMessage: (reservationUid: number | string = ':reservationId?') =>
    `/dashboard/messages/${reservationUid}`,
  reservationCancel: (reservationId: number | string = ':reservationId?') =>
    `/dashboard/reservations/${reservationId}/cancel`,
  reservationReputation: (reservationId: number | string = ':reservationId?') =>
    `/dashboard/reservations/${reservationId}/reputation`,
  reservationEdit: (reservationId: number | string = ':reservationId?') =>
    `/dashboard/reservations/${reservationId}/edit`,
  reservationChangeHost: (reservationId: number | string = ':reservationId?') =>
    `/dashboard/reservations/${reservationId}/request`,
  reservationChangeGuest: (
    reservationId: number | string = ':reservationId?',
  ) => `/dashboard/reservations/${reservationId}/confirm`,
  reservationSelectPayment: (
    reservationId: number | string = ':reservationId?',
  ) => `/dashboard/reservations/${reservationId}/select_payment`,
  reservationPayExamination: (
    reservationId: number | string = ':reservationId?',
  ) => `/dashboard/reservations/${reservationId}/pay_examination`,
  reservationChangePayment: (
    reservationId: number | string = ':reservationId?',
  ) => `/dashboard/reservations/${reservationId}/change_payment`,

  // 以下spmkt_webの方に飛ばす
  home: () => wwwUrl('/'),
  points: () => wwwUrl('/dashboard/points/available_point_histories'),
  settings: () => wwwUrl('/dashboard/settings/account'),
  referrals: () => wwwUrl('/referrals'),
  reservationReceipt: (reservationId: number) =>
    wwwUrl(`/dashboard/billings/${reservationId}/receipt`),
  owner: (ownerUsername: string) => wwwUrl(`${`/owners/${ownerUsername}`}`),
  roomReservationRequest: (
    spaceUsername: string,
    roomUid: string,
    reservationUid?: ?string,
  ) =>
    wwwUrl(
      `${`/spaces/${spaceUsername}/rooms/${roomUid}/reservations${
        reservationUid ? `?inquiry_id=${reservationUid}` : ''
      }`}`,
    ),
  user: (userUsername: string) => wwwUrl(`${`/users/${userUsername}`}`),
  capacity: (capacity: number) => wwwUrl(`/capacities/${capacity}`),
  area: (areaPath: string) => wwwUrl(`/areas/${areaPath}`),
  spaceType: (spaceType: string) => wwwUrl(`/space_types/${spaceType}`),
  eventType: (eventType: string) => wwwUrl(`/event_types/${eventType}`),
  reservationRequest: (
    spaceUsername: string,
    roomUid: string,
    planId?: string,
    searchSessionId?: string,
  ) => {
    const query = {}
    if (planId) query.plan_id = planId
    if (searchSessionId) query.search_session_id = searchSessionId
    const queryParam = queryString.stringify(query)
    return wwwUrl(
      `/spaces/${spaceUsername}/rooms/${roomUid}/reservations${
        queryParam ? `?${queryParam}` : ''
      }`,
    )
  },
  sentInquiry: (
    spaceUsername: string,
    roomUid: string,
    reservationUid: string,
  ) =>
    wwwUrl(
      `/spaces/${spaceUsername}/rooms/${roomUid}/inquiries/${reservationUid}/sent`,
    ),
  featureList: () => wwwUrl('/features'),
  feature: (featureId: string = ':featureId?') =>
    wwwUrl(`/features/${featureId}`),
  search: () => wwwUrl('/search'),
  searchCategory: (category: string, with_recommend?: boolean) =>
    `/search?event_type=${category}${
      with_recommend === true ? '&with_recommend=true' : ''
    }`,
  tokushoho: (ownerUsername: string) =>
    wwwUrl(`/owners/${ownerUsername}/tokushoho`),
  itinerary: (reservationUid: string) =>
    wwwUrl(`/itineraries/${reservationUid}`),
  paidSettings: () => wwwUrl(`/dashboard/settings/paid`),
  aboutPaid: () => wwwUrl(`/about/paid`),
  aboutPaidy: () => wwwUrl(`/about/paidy`),
  roomCancelPolicy: (room: RoomType) => {
    let policyUrl = '/about/cancel_policy'
    if (room.policy) {
      policyUrl = `/spaces/${(room.space || {}).username}/rooms/${
        room.uid
      }/cancel_policy`
    }
    return wwwUrl(policyUrl)
  },
  roomTerms: (room: RoomType) => {
    let termsUrl = '/about/terms_of_space_use'
    if (room.terms) {
      termsUrl = `/spaces/${room.space.username}/rooms/${room.uid}/terms`
    }
    return wwwUrl(termsUrl)
  },

  // ソーシャルシェア
  shareRoomTwitterUrl: (room: RoomType) => {
    const url = wwwUrl(`/spaces/${room.space.username}/rooms/${room.uid}`)
    return `https://twitter.com/intent/tweet?url=${url}&amp;text=${roomName(
      room,
    )}&amp;url=${url}`
  },
  shareRoomFacebookUrl: (room: RoomType) => {
    const url = wwwUrl(
      `/spaces/${room.space.username}/rooms/${room.uid}?utm_campaign=room-${
        room.uid
      }&utm_source=facebook&utm_medium=share`,
    )
    return `http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url,
    )}&amp;t=${roomName(room)}`
  },
  shareRoomLineUrl: (room: RoomType) => {
    const url = wwwUrl(
      `/spaces/${room.space.username}/rooms/${room.uid}?utm_campaign=room-${
        room.uid
      }&utm_source=line&utm_medium=share`,
    )
    return `http://line.me/R/msg/text/?${encodeURIComponent(
      `${roomName(room)} ${url}`,
    )}`
  },
  shareRoomGooglePlusUrl: (room: RoomType) => {
    const url = wwwUrl(`/spaces/${room.space.username}/rooms/${room.uid}`)
    return `https://plus.google.com/share?url=${url}`
  },

  // サービス間連携
  staySearch: () => stayUrl('/search'),
  stayRoom: (roomId: number) => stayUrl(`/rooms/${roomId}`),
  editRoom: (ownerName: string, room: RoomType) =>
    dashboardUrl({ username: ownerName }, `/rooms/${room.id}/edit`),
  eventServiceLp: (reservationId: string) =>
    eventUrl(`/lp/service?reservation=${reservationId}`),

  // Help
  helpPayment: () => helpPaymentUrl(),
}



// WEBPACK FOOTER //
// ./src/routes/path.js